// extracted by mini-css-extract-plugin
export default {"icon":"iconcolor_icon__5WfR4","action":"iconcolor_action__wg+QD"};